export default __webpack_public_path__ + "static/media/Diesel.08008852.svg";